// extracted by mini-css-extract-plugin
export var carrierIcon = "_ur-0";
export var carrierLogo = "_ur-1";
export var detailsSection = "_ur-2";